import { useNavigate } from 'react-router-dom'

import { DocumentTypes } from 'builder/modules/constants'
import { Routes } from '../constants'

type TrDocumentPreviewParams = {
  id: number
  path?: string
  disableEdit?: boolean
  isTailoringEnabled?: boolean
}

type DocumentPreviewParams = {
  id: number
  path?: string
}

export const usePreviewDocuments = () => {
  const navigate = useNavigate()

  const navigateToDocumentPreview = ({ id, path }: DocumentPreviewParams) => {
    const navigatePath = `?path=${path || Routes.TAILOR_RESUME}`
    navigate(`/documents/${id}/${DocumentTypes.resume}/preview${navigatePath}`)
  }

  const navigateToTrDocumentPreview = ({
    id,
    path,
    disableEdit,
    isTailoringEnabled,
  }: TrDocumentPreviewParams) => {
    const navigatePath = path || Routes.TAILOR_RESUME
    const edit = isTailoringEnabled && !disableEdit ? 'enabled' : 'disabled'
    navigate(`/tr-documents/${id}?edit=${edit}&path=${navigatePath}`)
  }

  return { navigateToDocumentPreview, navigateToTrDocumentPreview }
}
